// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3rgIQ","title":"card_title__2W-7-","inActive":"card_inActive__1ZJNh"};